import * as React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog'
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from '@material-ui/core/DialogTitle';
import { useHistory } from 'react-router-dom';
import {FormattedMessage} from "react-intl";

export default (props) => {
    const history = useHistory();

    return (
      <Dialog
        open={props?.open}
        onClose={() => props.setOpen(false)}
        role="alertdialog"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">
          <FormattedMessage id="return.dialog.title" />
        </DialogTitle>
        <DialogContent id="alert-dialog-description">
          <FormattedMessage id="return.dialog.description" />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="primary" onClick={() => props.setOpen(false)}>
            <FormattedMessage id={'continue.filling'} />
          </Button>
          <Button className={"afterDraftSaveButton"} variant="contained" color="primary" onClick={() => history.push(`/questionnaires/`)}>
            <FormattedMessage id={'navigate.to.questionnaires'} />
          </Button>
      </DialogActions>
      </Dialog>
    )
}